import { Box, Paper, Stack } from '@mui/material'

import React from 'react'
import { getPxAsRem } from 'shared/utils'
import CandidateMappingDataGrid from './CandidateMappingDataGrid'

export interface CandidatesTableProps {
    rosterId: string
}
const CandidatesMappingTable: React.FC<CandidatesTableProps> = ({
    rosterId,
}) => {
    return (
        <Stack
            component={Paper}
            borderRadius={getPxAsRem(8)}
            width={1}
            height={1}
            overflow={'hidden'}
        >
            <Box
                sx={{
                    flex: 1,
                    height: '100%',
                    overflow: 'hidden',
                }}
            >
                <CandidateMappingDataGrid rosterId={rosterId} />
            </Box>
        </Stack>
    )
}
export default CandidatesMappingTable
